import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { CONFIRM_SUBMIT_UI } from '../../constants/ui-strings'
import { QuestionsService } from 'src/app/services/questions.service';
import { TestService } from 'src/app/services/test.service';

@Component({
  selector: 'app-confirm-submit',
  templateUrl: './confirm-submit.component.html',
  styleUrl: './confirm-submit.component.scss'
})
export class ConfirmSubmitComponent implements OnInit, OnDestroy {
  attemptedQuestions: number = 0;
  totalQuestions: number = 0;
  unansweredQuestions: number = 0;
  attemptedQuestionCountSubscription$: Subscription;

  confirmSubmitUIStrings = CONFIRM_SUBMIT_UI;

  constructor (
    private questionsService: QuestionsService,
    private testService: TestService
  ) {}

  ngOnInit(): void {
    this.totalQuestions = this.questionsService.totalQuestions;
    this.attemptedQuestionCountSubscription$ = this.questionsService.attemptedQuestionCount$
      .subscribe({
        next: (attemptedQuestionCount) => {
          this.attemptedQuestions = attemptedQuestionCount
          this.unansweredQuestions = this.totalQuestions - attemptedQuestionCount
        }
      })
  }

  ngOnDestroy(): void {
    this.attemptedQuestionCountSubscription$?.unsubscribe();
  }

  finishTest(): void{
    this.testService.submitTest();
  }
  
}
